<template>
  <div class="sidebar-left">
    <div class="sidebar">
      <div class="sidebar-content" :class="{ 'show': mqShallShowLeftSidebar }" style="position: relative;">

        <!-- Header -->
        <div class="chat-fixed-search">
          <b-input-group class="input-group-merge w-100 round">
            <b-input-group-prepend is-text>
              <feather-icon icon="SearchIcon" class="text-muted" />
            </b-input-group-prepend>
            <b-form-input v-model="searchQuery" placeholder="Rechercher..." @input="debouncedSearch" />
          </b-input-group>
          <!-- Dropdown Filter -->
          <b-dropdown v-show="!mqShallShowLeftSidebar" dropright variant="link" no-caret>
            <template #button-content>
              <feather-icon icon="FilterIcon" :class="{ 'text-muted': !isFiltering, 'text-primary': isFiltering }" size="20" />
            </template>
            <b-dropdown-text>Filtrer par</b-dropdown-text>
            <b-dropdown-item class="w-100 text-left" @click="filterByAbsencesCalls">
              <feather-icon icon="PhoneMissedIcon" class="mr-1" size="17" />
              Appels en Absence
            </b-dropdown-item>
          </b-dropdown>
          <feather-icon v-show="mqShallShowLeftSidebar" class="ml-1 cursor-pointer" icon="XIcon" size="20"
                        @click="$emit('update:mq-shall-show-left-sidebar', false)" />
        </div>

        <GlobalSpinner :is-loading="isLoading" />

        <!-- Youngs -->
        <vue-perfect-scrollbar :settings="perfectScrollbarSettings"
                               class="chat-user-list-wrapper list-group scroll-area" @ps-y-reach-end="onScrollToBottom">
          <ul class="list-unstyled chat-users-list">
            <young-contact
              v-for="(young, index) in youngs"
              :key="young.id"
              :young="young"
              :class="[
                { 'active': activeChatYoungId === young.id },
                { 'archived': youngs[index] && youngs[index].conversationStatus === 3 }
              ]"
              tag="li"
              @click="$emit('open-chat', young.id)"
            />
          </ul>
          <div v-if="youngs.length === 0 && !isLoading" class="empty-state p-2 text-center text-muted">
            Aucun résultat trouvé
          </div>
        </vue-perfect-scrollbar>
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store'
import {
  BInputGroup,
  BInputGroupPrepend,
  BFormInput,
  BDropdown,
  BDropdownItem,
  BDropdownText,
} from 'bootstrap-vue'
import { computed, watch, ref } from '@vue/composition-api'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

import YoungContact from './YoungContact.vue'

export default {
  components: {
    BInputGroup,
    BInputGroupPrepend,
    BFormInput,
    BDropdown,
    BDropdownItem,
    BDropdownText,
    VuePerfectScrollbar,
    YoungContact,
  },
  props: {
    youngs: {
      type: Array,
      required: true,
    },
    activeChatYoungId: {
      type: Number,
      default: null,
    },
    mqShallShowLeftSidebar: {
      type: Boolean,
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    paginationInfo: {
      type: Object,
      // Exécuté seulement si pas de valeur transmise par le parent
      default: () => ({
        currentPage: 1,
        pageSize: 50,
        hasNext: false,
        hasPrevious: false,
      }),
    },
  },
  setup(props, { emit }) {
    const debounceTimeout = ref(null)
    const users = ref(computed(() => store.getters['users/users']))

    if (users.value.length === 0) {
      store.dispatch('youngs/fetchLastContacts')
    }

    const perfectScrollbarSettings = {
      maxScrollbarLength: 150,
    }

    watch(() => props.youngs, newYoungs => {
      const needsFetching = newYoungs.some(young => young && !young.lastMessageUser && young.lastMessageUserId)
      if (needsFetching) {
        store.dispatch('youngs/fetchLastContacts')
      }
    }, { immediate: true })

    const isFiltering = ref(false)
    const isFilteringByAbsencesCalls = ref(false)

    // Search handling with debounce
    const searchQuery = ref('')
    function debouncedSearch() {
      clearTimeout(debounceTimeout.value)
      debounceTimeout.value = setTimeout(() => {
        emit('search', {
          searchQuery: searchQuery.value,
          isFilteringByAbsencesCalls: isFilteringByAbsencesCalls.value,
          page: 1,
        })
      }, 700)
    }

    function toggleFilterIcon() {
      isFiltering.value = !isFiltering.value
    }

    async function filterByAbsencesCalls() {
      isFilteringByAbsencesCalls.value = !isFilteringByAbsencesCalls.value
      toggleFilterIcon()

      emit('search', {
        searchQuery: searchQuery.value,
        isFilteringByAbsencesCalls: isFilteringByAbsencesCalls.value,
        page: 1,
      })
    }

    function onScrollToBottom() {
      if (props.paginationInfo.hasNext && !props.isLoading) {
        emit('loadMore')
      }
    }

    return {
      perfectScrollbarSettings,

      // Search
      debouncedSearch,
      searchQuery,

      // Filter
      toggleFilterIcon,
      filterByAbsencesCalls,
      isFilteringByAbsencesCalls,
      isFiltering,

      onScrollToBottom,
    }
  },
}
</script>

<style scoped>
.spinner-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
}

.b-dropdown-text {
  font-weight: bold;
  color: #676d7d;
}

.empty-state {
  padding: 20px;
  font-style: italic;
}
</style>
